import React from "react";
import { Form, Row, Col, Select, Divider, Typography } from "antd";
import MoneyInput from "./MoneyInput";
import { optionsMonth } from "../../../../utils/constant/MonthSelect";
import ThaiDatePicker from "../../../../hook/ThaiDatePicker";
import { CalendarOutlined } from "@ant-design/icons";
import { formatMoney } from "../../contractDetailNew/contractDetailNew/utils";

const { Text } = Typography;

const FormPaymentSection = ({
  form,
  radioDecide,
  radioFinish,
  onChangeDateAgreement,
  onChangePaydue,
}) => {
  const showInstallment = radioDecide === "agreement";

  const watchedPaymentDue = Form.useWatch("paymentDue", form);
  const watchedPerMonth = Form.useWatch("paymentPerMonthAmount", form);
  const watchedMonths = Form.useWatch("costMonth3", form);

  // ยอดยินยอม - (ค่างวด x จำนวนเดือน) คำนวณเป็นสตางค์ เพื่อเลี่ยงปัญหาทศนิยม
  const calcBalanceAfter = (total, months, perMonth) =>
    (Math.round((parseFloat(total) || 0) * 100) -
      (Number(months) || 0) * Math.round((parseFloat(perMonth) || 0) * 100)) /
    100;
  const balanceAfter = calcBalanceAfter(
    watchedPaymentDue,
    watchedMonths,
    watchedPerMonth,
  );
  const showBalanceAfter = !!watchedMonths && !!watchedPerMonth;

  return (
    <>
      <Divider orientation="left">🤝 ทำยอม</Divider>
      <Form.Item
        label="ยินยอมชำระเงินจำนวน"
        name="paymentDue"
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 14 }}
        rules={[{ required: true, message: "กรุณาใส่เงินต้นที่ทำยอม" }]}
      >
        <MoneyInput placeholder="กรุณาใส่จำนวนเงิน" onChange={onChangePaydue} />
      </Form.Item>

      {showInstallment && (
        <Row gutter={16} align="middle" style={{ marginBottom: "20px" }}>
          <Col span={12}>
            <Form.Item
              label="งวดละไม่น้อยกว่า"
              name="paymentPerMonthAmount"
              style={{ marginBottom: 20 }}
              labelCol={{ span: 12 }}
              rules={[
                { required: true, message: "กรุณาใส่เงินที่ต้องชำระรายเดือน" },
              ]}
            >
              <MoneyInput placeholder="กรุณาใส่จำนวนเงิน" />
            </Form.Item>
            <Form.Item
              label="วันนัดชำระครั้งแรก"
              name="dueDate"
              style={{ marginBottom: 0 }}
              labelCol={{ span: 12 }}
              rules={[{ required: true, message: "โปรดเลือกวันที่นัดชำระ" }]}
            >
              <ThaiDatePicker
                placeholder="กรุณาเลือกวันที่"
                size="large"
                style={{ width: "100%" }}
                suffixIcon={<CalendarOutlined />}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="จำนวนกี่เดือน"
              name="costMonth3"
              style={{ marginBottom: 60 }}
              labelCol={{ span: 6 }}
              dependencies={["paymentDue", "paymentPerMonthAmount"]}
              rules={[
                { required: true, message: "กรุณาใส่จำนวนงวด" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const perMonth = getFieldValue("paymentPerMonthAmount");
                    if (
                      !value ||
                      !perMonth ||
                      calcBalanceAfter(
                        getFieldValue("paymentDue"),
                        value,
                        perMonth,
                      ) >= 0
                    ) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "ค่างวด x จำนวนเดือน เกินยอดยินยอมชำระ กรุณาลดจำนวนเดือน",
                      ),
                    );
                  },
                }),
              ]}
            >
              <Select
                showSearch
                size="large"
                style={{ width: "100%" }}
                popupMatchSelectWidth={false}
                optionFilterProp="label"
                options={optionsMonth}
                placeholder="เลือกจำนวนเดือน"
                allowClear
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            {showBalanceAfter && (
              <Form.Item
                label="คงเหลือหลังผ่อนให้ไปรวมกับงวดสุดท้าย"
                style={{ marginBottom: 0 }}
                labelCol={{ span: 12 }}
              >
                <Text strong type={balanceAfter < 0 ? "danger" : "success"}>
                  {formatMoney(balanceAfter)} บาท
                </Text>
              </Form.Item>
            )}
          </Col>
        </Row>
      )}
    </>
  );
};

export default FormPaymentSection;
